import http from '@/shared/http.service';
import { Uris, DefaultConfig } from '@/shared/const';
import { Subject, from, EMPTY } from 'rxjs';
import { ref, onUnmounted, reactive, computed, onMounted } from 'vue';
import { Form, notification } from "ant-design-vue";
import { catchError, switchMap, throttleTime } from 'rxjs/operators';
import dayjs from 'dayjs';
import { useIdentityStore } from '@/stores/useIdentityStore';
import { useRouter } from 'vue-router';


const useForm = Form.useForm;
export default function useClue() {
    const store = useIdentityStore();
    const router = useRouter();
    const currentUser = computed(() => store.currentUser);


    const form = reactive({
        id: "",
        linkName: "",
        linkPhone: "",
        email: "",
        postName: "",
        companyName: "",
        centerId: '',
        title: '',
        source:'',
        message:''
    });

    let rules = reactive({
        linkName: [{ type: 'string', required: true, message: '请输入联系人姓名', trigger: 'change' }],
        linkPhone: [{ type: 'string', required: true, message: '请输入联系人电话', trigger: 'change' }],
        // companyName: [{ type: 'string', required: true, message: '请输入企业/单位名称', trigger: 'change' }],

    });

    let { resetFields, validate, validateInfos } = useForm(form, rules);

    //保存
    const saved$ = new Subject();
    const handleSave = (formData) => {
        from(validate()).pipe(
            switchMap(validateResult => {
                return http.post(Uris.CluePost, formData);
            }), catchError((err, caught) => {
                console.log(err);
                return EMPTY;
            })
        ).subscribe(result => {
            notification.success({
                message: '数据已保存',
                description: '',
                duration: 2
            });
            //恢复字段验证规则
            saved$.next();
        });
    };


    const defaultOrderBy = 'ViewCount';
    const defaultDirection = 'Desc';
    const params = reactive({
        pageIndex: 1,
        pageSize: DefaultConfig.PageSize,
        orderBy: defaultOrderBy,
        direction: defaultDirection,
    });

    const pagination = reactive({
        current: 1,
        pageSize: DefaultConfig.PageSize,
        total: 0
    });

    //分页
    const handleTableChange = (pager) => {
        // console.log(pager)
        const serchEntity = {
            title: params.title ? params.title : "",
            pageIndex: pager.current,
            pageSize: pager.pageSize,
            orderBy: params.orderBy ? params.orderBy : '',
            direction: params.direction ? params.direction : '',
        };
        getClueList(serchEntity);
    };

    const clueList = ref([]);
        //获取列表
        const getResource$ = new Subject();
        const getResourceSubscription = getResource$.pipe(
            switchMap((request) => http.get(Uris.ClueList, request))
        ).subscribe(result => {
    
            clueList.value = result.list;
            if (!result.hasNextPage) {
                pagination.current = result.totalPageCount > 0 ? result.totalPageCount : 1;
            } else {
                pagination.current = result.pageIndex;
            }
            pagination.pageSize = result.pageSize;
            pagination.total = result.totalCount;
    
        });
    
        const getClueList = (requestModel) => {
            if (requestModel) {
                params.title = requestModel.title;
                params.pageIndex = requestModel.pageIndex;
                params.pageSize = requestModel.pageSize;
            }
            getResource$.next(params);
        };

     onUnmounted(() => {
       getResourceSubscription.unsubscribe();
    });

    return {
       
        resetFields,
        validate,
        validateInfos,
        handleSave,
        form,
        saved$,
        currentUser,
        clueList,
        getClueList,
        pagination,
        handleTableChange,
    };

}